import type { PaymentObserverPayment } from "@workspace/api-client-react";
const expectedReason = "Cash, shop credit or another non-Stripe payment: no captured Stripe receipt to certify.";
/** Explicit payment methods only: a missing card receipt must still need review. */
export function nonStripePayment(row: Pick<PaymentObserverPayment, "paymentIntentId" | "status" | "result" | "reasons">) {
  if (row.paymentIntentId || !["cash", "shop_credit"].includes(row.status)) return null;
  const cash = row.status === "cash";
  const additionalChecks = row.result === "fail" || row.reasons.length === 0 || row.reasons.some(reason => reason !== expectedReason);
  const explanation = cash
    ? "Cash order — Stripe checks are not applicable. This page does not confirm whether the cash has been collected."
    : "External driver request — charged to the shop ledger. No customer Stripe payment is expected for this request. Delivery, fuel and Hub charges are recorded on the shop ledger.";
  return { cash, label: cash ? "Cash order" : "Shop ledger", additionalChecks, explanation,
    reasons: row.reasons.map(reason => reason === expectedReason ? explanation : reason) };
}
